import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialogRef } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { myFilter } from 'utilities/util';
import { Cobradores } from 'app/entities/cobranza';

@Component({
  selector: 'app-reprogramar-cobro',
  templateUrl: './reprogramar-cobro.component.html',
  styleUrls: ['./reprogramar-cobro.component.scss']
})
export class ReprogramarCobroComponent implements OnInit {

  newForm: FormGroup;
  public myFilter = myFilter;
  public cobradores: Array<Cobradores> = [];

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   * @param {MatSnackBar} _snackBar 
   * @param {FormBuilder} _formBuilder 
   * @param {MatDialogRef<ReprogramarCobroComponent>} dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _cartera: CarteraService, 
    private _snackBar: MatSnackBar, 
    private _formBuilder: FormBuilder,
    public dialog: MatDialogRef<ReprogramarCobroComponent>
  ) 
  { 
    this.newForm = new FormGroup({
      informacionGrupo:  this._formBuilder.group({
        ID_grupo: new FormControl(_data.ID_grupo),
        Radicado: new FormControl(_data.Radicado),
        Empresa: new FormControl(_data.Empresa)
      }),
      id_cobro: new FormControl(_data.ID_cobro),
      info_cobrador: this._formBuilder.group({
        cobrador: new FormControl(null, [
          Validators.required
        ]),
      }),
      reprogramacion: this._formBuilder.group({
        tipo_reprog: new FormControl(null, [
          Validators.required
        ]),
        fecha: new FormControl(null, [
          Validators.required
        ]),
        usuario: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario']),
      }),
      antiguo_estado: new FormControl(_data.EstadoCobro),
      nuevo_estado: new FormControl('4')
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit() {
    this._cartera.VerCobradores().subscribe((data: Array<any>) => {
      data.forEach((element, i) => {
        this.cobradores[i] = {
          codigo: element.documento_usuario,
          nombre: element.nombre_completo
        }
      });
    });
  }

  /**
   * 
   * @param form 
   */
  public guardarReprog(form: any){
    // Condición: Sí el formulario tiene por estado 'INVALID', muestra un mensaje de error
    if(this.newForm.status === 'INVALID'){
      this._snackBar.open('Faltan campos por llenar', 'x', {
        duration: 2500,
        panelClass: 'yellow'
      });
      return; 
    }

    //Aplicación del Formato Año-Mes-Dia al campo fecha_reprog del objeto newForm
    form['reprogramacion'].fecha = moment(form['reprogramacion'].fecha).format('YYYY-MM-DD');

    this._cartera.GuardarReprogramacion(form, form.id_cobro).subscribe((data: any) => {
      // Condición: Si existen filas afectadas, muestra un mensaje de éxito y cierra el modal, retornando un verdadero(TRUE), de lo contrario, muestra un mensaje de error
      if(data.affectedRows == 1){
        this._snackBar.open('Reprogramación Exitosa', 'Aceptar', {
          duration: 2000
        });
        this.dialog.close(true);
      }else{
        this._snackBar.open('Error al reprogrmar el cobro', '', {
          panelClass: ['warn-600'],
          duration: 2000
        });
      }
    });
  }

}
